import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createMailingTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/mailingTemplates`
    },
    updateMailingTemplate: {
        url: `${BASE_PATH_API}/communication/mailingTemplates/:id`,
        method: 'PUT'
    },
    getMailingTemplate: {
        url: `${BASE_PATH_API}/communication/mailingTemplates/:id`,
        method: 'GET'
    },
    getMailingTemplates: {
        url: `${BASE_PATH_API}/communication/mailingTemplates`,
        method: 'GET'
    },
    getMailingEmailTemplates: {
        url: `${BASE_PATH_API}/mailingEmailTemplates`,
        method: 'GET',
        isArray: true
    },
    getAwatChecklistMailTemplateSettings: {
        url: `${BASE_PATH_API}/communication/mailingTemplates/:id/awatChecklistMailTemplateSettings`,
        method: 'GET'
    },
    copyMailingTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/mailingTemplates/copy/:id`
    },
    getRecipientMailingTemplates: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailingTemplates/:recipientTypeId/templates`,
        isArray: true
    },
    getRecipientMailingTemplatesCached: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailingTemplates/:recipientTypeId/templates`,
        isArray: true,
        cache: true,
    },
    getRecipientMailingTemplateForGroupEmail: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailingTemplates/:recipientTypeId/groupEmailTemplates`,
        isArray: true
    },

    getTemplateContent: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailingTemplates/:templateId/content`
    },

    deleteMailingEmailTemplates: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/mailingEmailTemplates/:templateId`
    },

    restoreDefaultMailingTemplates: {
        method: 'PUT',
        url: `${BASE_PATH_API}/mailingEmailTemplates/restoreDefaults`
    },

    getMailingEmailTemplatesRecipients: {
        url: `${BASE_PATH_API}/mailingEmailTemplates/recipients`,
        method: 'GET',
        isArray: true
    },

    getMailingEmailTemplatesPaged: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailingEmailTemplates`
    }
};

export const MailingTemplateApi = function MailingTemplateApi() {
    const service = createActions(actions);

    service.getMailingTemplatePreviewURL = function getMailingTemplatePreviewURL(templateId) {
        return `${BASE_PATH_API}/mailingEmailTemplates/${templateId}/preview`;
    };

    return service;
};
